import React, { useState } from 'react';
import { useAuth } from '../../components/user/AuthProvider';
import { useNavigate, Link } from 'react-router-dom';
import { useRoleLinks } from '../../hooks/useNav';
import { FiChevronDown } from 'react-icons/fi';
import MenuLink from './MenuLink';

const NavLinks = ({ profileInfo, onClose }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { items: drawerItems } = useRoleLinks(profileInfo?.role);
  // Index of the expanded parent item (null = all collapsed).
  const [expandedIndex, setExpandedIndex] = useState(null);

  const handleLogout = () => { 
    logout(); 
  };

  const handleLinkClick = (index) => {
    if (onClose) {
      onClose(); // Close the drawer when a link is clicked
    }
  };

  return (
    <>
        {drawerItems.map((item, index) => (
          item.children ? (
            <div key={`${index}_navlink`}>
              <button
                type="button"
                onClick={() => setExpandedIndex(expandedIndex === index ? null : index)}
                className="w-full text-center hover:bg-primary transition-all duration-300 py-3"
              >
                <div className="inline-flex items-center justify-center gap-2">
                  <h4 className="text-base font-medium">
                    {item.label}
                  </h4>
                  <FiChevronDown
                    className={`transition-transform duration-200 ${expandedIndex === index ? 'rotate-180' : ''}`}
                  />
                </div>
              </button>
              {expandedIndex === index && (
                <div className="bg-gray-50">
                  {item.children.map((child, childIndex) => (
                    <MenuLink
                      key={`${index}_${childIndex}_navlink`}
                      item={child}
                      onClick={() => handleLinkClick(index)}
                      className="block text-center hover:bg-primary transition-all duration-300 py-2"
                    >
                      <h4 className="text-sm font-normal">
                        {child.label}
                      </h4>
                    </MenuLink>
                  ))}
                </div>
              )}
            </div>
          ) : (
            <MenuLink
              key={`${index}_navlink`}
              item={item}
              onClick={() => handleLinkClick(index)}
              className="block text-center hover:bg-primary transition-all duration-300 py-3"
            >
              <div className="inline-flex items-center justify-center gap-2">
                <h4 className="text-base font-medium">
                  {item.label}
                </h4>
              </div>
            </MenuLink>
          )
        ))}
        <Link to="#" onClick={handleLogout}>
          <h4 className="text-base font-medium text-center hover:bg-primary transition-all duration-300 py-3">
            Logout
          </h4>
        </Link>
    </>
  );
};

export default NavLinks;
